// extracted by mini-css-extract-plugin
export default {"sizeWrapper":"styles_sizeWrapper__01KsM"};